import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-ink px-3 py-4 sm:px-6" data-id="element-94" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl items-start gap-2.5 rounded-md border-2 border-hazard bg-graphite px-3 py-2.5" data-id="element-95" data-mp="1o3dmwcdeadr5">
        <ShieldCheckIcon className="mt-0.5 h-9 w-9 shrink-0 text-hazard" strokeWidth={1.6} aria-hidden="true" data-id="element-96" data-mp="22124nbc614rz" />
        <div data-id="element-97" data-mp="19ehg0in2r6s4">
          <h2 className="font-display text-[1.05rem] font-extrabold uppercase leading-none text-white sm:text-[1.45rem]" data-id="element-98" data-mp="19e7m4jywsfh5">
            YOUR PURCHASE IS <span className="text-hazard" data-id="element-99" data-mp="14h8ty6yt2ill">100% PROTECTED</span>
          </h2>
          <p className="mt-1 text-[0.78rem] leading-[1.35] text-steel sm:text-[0.9rem]" data-id="element-100" data-mp="1j5lsnbpa2fjs">
            Explore CONSTRUCTION SITE PRO™ for 7 days. Access the complete 6-module construction
            management system and all 5 strategic bonuses. If it isn't right for you, contact us within
            7 days for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}